/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useState } from 'react';
import './UtilityBillUploadBodyTheme.scss';
import { ViewBillDetailsFormComponent } from './ViewBillDetailsFormComponent';
import { BillMonthYearDetailView } from './BillMonthYearDetailView';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import useConnectorAndDynamicProps from '../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import { Loader } from '@scuf/common';

const UtilityBillUploadBody = (props: IAny) => {
  const {
    bearerToken,
    requestContext,
    isNewBill,
    billDetails,
    utilityCellData,
    monthYearData,
    isPDFExtracted,
    setIsPDFExtracted,
    addNewBill,
    setRefreshTable,
    isMultipleUploaded,
    setIsMultipleUploaded,
    setIsWrongFile,
    isWrongFile
  } = props;

  return (
    <>
      <div className="manage-bill-container">
        <div className="left-container">
          <BillMonthYearDetailView
            onBillClick={props.onBillClick}
            data={monthYearData}
            isNewBill={isNewBill}
            utilityCellData={utilityCellData}
            isPDFExtracted={isPDFExtracted}
            isMultipleUploaded={isMultipleUploaded}
            billDetails={billDetails}
          />
        </div>
        <div className="space"></div>
        <div className="right-container">
          {props.billClickLoader ? (
            <Loader overlayColor={'transparent'} />
          ) : (
            <ViewBillDetailsFormComponent
              {...props}
              billDetails={billDetails}
              isNewBill={isNewBill}
              utilityCellData={utilityCellData}
              setIsNewBill={props.setIsNewBill}
              newBillClick={props.newBillClick}
              setPDFResponse={props.setPDFResponse}
              isPDFExtracted={isPDFExtracted}
              setIsPDFExtracted={setIsPDFExtracted}
              addNewBill={addNewBill}
              setRefreshTable={setRefreshTable}
              isMultipleUploaded={isMultipleUploaded}
              setIsMultipleUploaded={setIsMultipleUploaded}
              setIsWrongFile={setIsWrongFile}
              isWrongFile={isWrongFile}
              // data={data}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default UtilityBillUploadBody;
